export let MENU_ITEM = [

    {
        path: 'manage/trackapp',
        title: 'Tracking Download',
        icon: 'bar-chart'
    },
    {
        path: 'manage/app-list',
        title: 'Uploading App',
        icon: 'file-text-o'
    }
];
